import useMyVendorRequestAccess from "../../custom-hooks/useMyVendorRequestAccess";
import { getLockedMyVendorRequestTooltip } from "../../utils/myVendorsRequestAccess";
import { classNames } from "./myVendorRequestBadgeLock";

export function resolveLastQualifiedRequest(vendor) {
  const targetId = vendor?.lastQualifiedRequest?.id;
  if (!targetId) return null;
  return (
    [...(vendor.myRequests || []), ...(vendor.libraryRequests || [])].find(
      (req) => String(req.id) === String(targetId)
    ) || vendor.lastQualifiedRequest
  );
}

/**
 * Last Qualified Date cell control — respects VQQ/VQA manager lockdown.
 */
export default function MyVendorLastQualifiedDateButton({
  vendor,
  onClick,
}) {
  const { canOpenRequest, isVqaOnly } = useMyVendorRequestAccess();
  const request = resolveLastQualifiedRequest(vendor);
  const isLocked = Boolean(request) && !canOpenRequest(request);

  if (!vendor?.lastQualifiedDate) {
    return <span className="text-gray-400">—</span>;
  }

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        if (isLocked) return;
        onClick?.(vendor);
      }}
      aria-disabled={isLocked || undefined}
      title={isLocked ? getLockedMyVendorRequestTooltip(request, { isVqaOnly }) : undefined}
      className={classNames(
        "text-left",
        isLocked
          ? "cursor-not-allowed opacity-60"
          : "hover:text-indigo-600 hover:underline"
      )}
    >
      {vendor.lastQualifiedDate}
    </button>
  );
}
